import { Dialog } from "../../../../../../components/modal/Dialog";
import { StorefrontTableCategoryDialogContent } from "./StorefrontTableCategoryDialogContent";

export const StorefrontTableCategoryDialog = ({
  active,
  onDismiss,
  productId,
  setBestPricePromiseDialogActive,
}: {
  active: boolean;
  onDismiss: () => void;
  productId: number;
  setBestPricePromiseDialogActive?: (active: boolean) => void;
}) => {
  return (
    <Dialog
      active={active}
      onDismiss={onDismiss}
      fullHeight={true}
      className="w-full max-w-[1000px] rounded-none md:rounded-lg"
    >
      <StorefrontTableCategoryDialogContent
        productId={productId}
        setBestPricePromiseDialogActive={setBestPricePromiseDialogActive}
        onDismiss={onDismiss}
      />
    </Dialog>
  );
};
